import { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

const InteractiveMap = lazy(() => import('../InteractiveMap'));

const SliderTrackMap = props => (
  <Suspense fallback={null}>
    <InteractiveMap {...props.item} mapId="slider-map" />
  </Suspense>
);

SliderTrackMap.propTypes = {
  item: PropTypes.shape({
    coords: PropTypes.arrayOf(PropTypes.number),
    countryCode: PropTypes.string,
    areaSlug: PropTypes.string
  }).isRequired
};

export default SliderTrackMap;
